export const iconFontAwesomeReligionBahai = (
	<i className="fa-solid fa-bahai"></i>
);
